import { BaseService } from 'core/services';
import InventoryRequestRouteService from './InventoryRequestRouteService';

class InventoryRequestService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new InventoryRequestRouteService());
    }

    getDownloadUrl(){
        return this.apiClient.appOptions.apiUrl + this.routeService.download();
    }

    getEmailPrefillData(facilityOrderId, inventoryRequestType) {
        const url = this.routeService.getEmailPrefillData(facilityOrderId, inventoryRequestType);
        return this.apiClient.get(url);
    }

    getNikoEmailPrefillData(facilityOrderId, inventoryRequestType) {
        const url = this.routeService.getNikoEmailPrefillData(facilityOrderId, inventoryRequestType);
        return this.apiClient.get(url);
    }

    sendEmail(resource) {
        const url = this.routeService.sendEmail(resource);
        return this.apiClient.post(url, resource);
    }

    getInventoryFollowUpPrefill(facilityOrderId){
        const url = this.routeService.getInventoryFollowUpPrefill(facilityOrderId);
        return this.apiClient.get(url);
    }

    getInventoryNotReceivedPrefill(facilityOrderId){
        const url = this.routeService.getInventoryNotReceivedPrefill(facilityOrderId);
        return this.apiClient.get(url);
    }

    getInventoryAssistanceRequestPrefill(facilityOrderId){
        const url = this.routeService.getInventoryAssistanceRequestPrefill(facilityOrderId);
        return this.apiClient.get(url);
    } 

    getAssistanceEmailPrefillData(facilityOrderId){
        const url = this.routeService.getAssistanceEmailPrefillData(facilityOrderId);
        return this.apiClient.get(url);
    }

    checkIsInventoryRequestEligible(facilityOrderId){
        const url = this.routeService.checkIsInventoryRequestEligible(facilityOrderId);
        return this.apiClient.get(url);
    }

    checkIsNikoInventoryRequestEligible(facilityOrderId){
        const url = this.routeService.checkIsNikoInventoryRequestEligible(facilityOrderId);
        return this.apiClient.get(url);
    }

    checkSharedInventoryEmailConditions(facilityOrderId){
        const url = this.routeService.checkSharedInventoryEmailConditions(facilityOrderId);
        return this.apiClient.get(url);
    }

    checkSharedNikoInventoryEmailConditions(facilityOrderId){
        const url = this.routeService.checkSharedNikoInventoryEmailConditions(facilityOrderId);
        return this.apiClient.get(url);
    }
}

export default InventoryRequestService;
